import type { RoleConfig } from '../types.js';

export const don: RoleConfig = {
  id: 'don',
  faction: 'mafia',
  title: { ru: 'Дон', uk: 'Дон' },
  latin: 'IL DON',
  number: '08',
  accent: '#d4a019',
  sub: '#8a6610',
  ability: {
    ru: 'Голос решающий при ничьей среди мафии. Ночью может проверить шерифа.',
    uk: 'Голос вирішальний при нічиї серед мафії. Вночі може перевірити шерифа.',
  },
  abilities: [
    {
      key: 'kill',
      phase: 'night',
      cadence: 'mandatory-night',
      canSelfTarget: false,
      killGroup: 'mafia',
    },
    {
      key: 'check',
      phase: 'night',
      cadence: 'every-night',
      canSelfTarget: false,
    },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
  seniority: 100,
};
